import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { USAStateEnum } from '@trp/community/auth/interfaces';
import {
  MenuDefinition,
  MenuItem,
  MenuService,
} from '@trp/community/menu/data-access';

@Component({
  selector: 'community-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TopbarComponent implements OnInit {
  @Input() stateName: USAStateEnum | undefined;
  @Input() disableNavigation = false;
  constructor(private menuService: MenuService) {}
  menuDefinition: MenuDefinition;

  getNavLinkClass(item: MenuItem) {
    if (item.external) {
      return ['nav-link', 'external-link'];
    }

    return ['nav-link'];
  }

  ngOnInit(): void {
    this.menuDefinition = this.menuService.getStateMenu(this.stateName);
  }
}
